import { Expose } from 'class-transformer';

import type ImageInterface from '../types/Image';
import type OptionGroupInterface from '../types/OptionGroup';
import type MetaDataInterface from '../types/MetaData';
import type ItemCustomData from '../types/CustomData';

export default class Product {
  @Expose() id: string = "";
  @Expose() chainproductid: string = "";
  @Expose() name?: string = "";
  @Expose() description?: string = "";
  @Expose() images?: ImageInterface[] = [];
  @Expose() optiongroups?: OptionGroupInterface[] = [];
  @Expose() options?: number[] = [];
  @Expose() cost: number = 0;
  @Expose() metadata?: MetaDataInterface[] = [];
  @Expose() quantity: number = 1;
  @Expose() feeds: number[] = [0,0,0];
  @Expose() custom_data: ItemCustomData = {
    vegan: false,
    vegetarian: false,
    gluten_free: false,
    dairy_free: false,
    nut_free: false,
    soy_free: false,
    addon_products: {}
  }
  @Expose() cost_with_defaults: number = 0

  constructor(id: string, name: string, chainproductid: string, optiongroups: OptionGroupInterface[], options: number[], description: string,  cost: number, images: ImageInterface[], metadata: MetaDataInterface[], quantity: number, productaddons: Map<string, number>, feeds: number[], custom_data: ItemCustomData, cost_with_defaults: number) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.images = images;
    this.optiongroups = optiongroups;
    this.options = options;
    this.cost = cost;
    this.chainproductid = chainproductid;
    this.metadata = metadata;
    this.quantity = quantity;
    this.feeds = feeds;
    this.custom_data = custom_data;
    this.cost_with_defaults = cost_with_defaults
  }

  getImageByKey = (key: string) => {
    if (this.images) {
      const keyedImages = this.images.filter(img => {
        return img.position == key
      })
      return keyedImages.length > 0 ? keyedImages[0] : null;
    } else {
      return null
    }
  }

  getMetaDataByKey = (key: string) => {
    let data = null;
    if (this.metadata) {
      data = this.metadata.find(md => {
        return md.key == key
      })
    }

    return data ? data.value : null;
  }

  isCatering = (): boolean => {
    let catering = false;

    if (this.getMetaDataByKey('catering')) {
      catering = true;
    }

    return catering;
  }

  // feeds = ():number[] => {
  //   let arr = [0,0,0]

  //   if (this.getMetaDataByKey('feedCount')) {
  //     const meta = this.getMetaDataByKey('feedCount');
  //     arr = JSON.parse(meta)
  //   }

  //   return arr;
  // }

  priceWithDefaults = ():number => {
    let cost = this.cost;

    // cost_with_defaults is always >= cost, but throwing this check here to be safe
    if (this.cost_with_defaults && this.cost_with_defaults > 0) {
      cost = this.cost_with_defaults
    }

    return cost;
  }
}
